import React from 'react';
import { industries } from '../mock';
import * as LucideIcons from 'lucide-react';

const Industries = () => {
  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="mb-16 text-center">
          <span className="caption mb-4 block">
            Industries We Serve
          </span>
          <h2 className="heading-2 mb-6">
            Sector Expertise
          </h2>
          <p className="body-medium max-w-3xl mx-auto">
            Serving diverse industries with specialized knowledge and tailored solutions
          </p>
        </div>

        {/* Industries Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {industries.map((industry, index) => {
            const Icon = LucideIcons[industry.icon];
            return (
              <div
                key={index}
                className="bg-white p-6 rounded-lg border border-[hsl(var(--border-light))] hover:border-[hsl(var(--primary-blue))] hover:shadow-lg transition-all duration-300 text-center group"
              >
                <div className="w-14 h-14 bg-[hsl(var(--primary-blue)/.1)] rounded-lg flex items-center justify-center mb-4 mx-auto group-hover:bg-[hsl(var(--primary-blue)/.15)] transition-colors">
                  {Icon && <Icon className="text-[hsl(var(--primary-blue))]" size={28} />}
                </div>
                <p className="body-small font-medium leading-tight text-[hsl(var(--text-primary))]">
                  {industry.name}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Industries;
